import instance from './api';

/**
 * AI menu import. Talks to api01, which proxies to the menu-ai-parser service.
 * The service only produces the import JSON; the caller posts that payload to
 * the existing import endpoint for its menu type.
 */

// POST {API}/api01/menu/ai-import -> { uuid, status }
export const createAiMenuImport = async ({
  businessUuid,
  target,
  instructions,
  files,
}) => {
  const formData = new FormData();
  formData.append('businessUuid', businessUuid);
  formData.append('target', target);
  if (instructions) {
    formData.append('instructions', instructions);
  }
  files.forEach((file) => formData.append('files', file, file.name));

  const response = await instance.post('/menu/ai-import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

// GET {API}/api01/menu/ai-import/:uuid -> { status, menu, warnings, error, ... }
export const getAiMenuImport = async (uuid) => {
  const response = await instance.get(`/menu/ai-import/${uuid}`);
  return response.data.data;
};

// POST {API}/api01/menu/ai-import/:uuid/retry
export const retryAiMenuImport = async (uuid) => {
  const response = await instance.post(`/menu/ai-import/${uuid}/retry`);
  return response.data.data;
};
